<ui-dialog width="sm">
  <ng-container dialog-title>
    <div class="font-grotesk-32px mb-10 text-cp-primary-100">
      So sortieren wir Ergebnisse
    </div></ng-container
  >
  <ng-container dialog-content>
    <div class="flex justify-center mb-6">
      <mat-icon svgIcon="cp-success-with-to-do" class="!w-[75px] !h-[75px]" />
    </div>
    <div>
      Standardmäßig werden die Tarife nach Beitrag sortiert, wobei der günstigste Tarife ganz oben
      steht. Alternativ kannst du die Ansicht auch mittels Klick auf das Doppelpfeilsymbol (links
      über den Ergebnissen) alphabetisch von A nach Z nach Versicherer sortieren.
    </div>
  </ng-container>
</ui-dialog>
